// PlaceManager.js
var PlaceManager = pc.createScript('placeManager');

PlaceManager.attributes.add("closePlaceItems", {type: "entity", array: true});
PlaceManager.attributes.add("openPlaceItems", {type: "entity", array: true});
PlaceManager.attributes.add("placesUIPanel", {type: 'entity'});


var loadLevelData;
var placesButtonIsClicked = false;


PlaceManager.prototype.initialize = function() {

    PlaceManager.instance = this;
    placesButtonIsClicked = false;
    this.initButtons();

    if ((PlayerManager.instance.userData.gameMode === gamePlayMode.Places) && (showPlaceModUI === true)) {
        this.initPlace();
        this.placesUIPanel.enabled = true;
    }
};

PlaceManager.prototype.initPlace = function(){
    
    if(PlayerManager.instance.userData.unlockLevel == true){

        for(let i = 0; i < this.openPlaceItems.length; i++){
            this.closePlaceItems[i].enabled = false;
            this.openPlaceItems[i].enabled = true;
        }
    }
    else{
        this.newDefineScenePanel();
    }
};

PlaceManager.prototype.initButtons = function(){


    
    this.openPlaceItems[0].children[1].button.on('click', function (event) {
        
        let unlockStatus = PlayerManager.instance.userData.unlockLevel;

        if (!placesButtonIsClicked) {

            if ((unlockStatus == true) || loadLevelData>3) {

                loadLevelData = 3;
            }

            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "HobbyRoomButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(loadLevelData);
        }
        
    },this);   
    
    this.openPlaceItems[1].children[1].button.on('click', function (event) {
        
        let unlockStatus = PlayerManager.instance.userData.unlockLevel;

        if (!placesButtonIsClicked) {
            
             if ((unlockStatus == true) || loadLevelData>5) {
                
                loadLevelData = 5;
            }
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "KidsRoomButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(loadLevelData);

        }
        
    },this); 
    
    this.openPlaceItems[2].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "SchoolButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(6);
        }
        
    },this); 

    this.openPlaceItems[3].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "FarmersMarketButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(7);
        }
        
    },this); 

    this.openPlaceItems[4].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "BedroomButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(8);
        }
        
    },this);
    
    this.openPlaceItems[5].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "CellarButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(9);
        }
        
    },this);
    
   this.openPlaceItems[6].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "KitchenButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(10);
        }
        
    },this);
    
   this.openPlaceItems[7].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "FoodCourtButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(11);
        }
        
    },this);
    
   this.openPlaceItems[8].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "GymButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(12);
        }
        
    },this);

   this.openPlaceItems[9].children[1].button.on('click', function (event) {
        
        if (!placesButtonIsClicked) {
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "LivingRoomButton:Click", 1);}
            placesButtonIsClicked =true;
            this.loadPlacesScene(13);
        }
        
    },this);
};

PlaceManager.prototype.loadPlacesScene = function(placesRoomIndex) {
    
    loadScene(`LoadingScene`, { hierarchy: true, settings: true }, () => {

        GameManager.instance.LoadPlaceData(placesRoomIndex, function (status) {
            
            if (status == true) {
                PreloadManager.instance.loadGameAssets(GameManager.instance.placeData.levelItem, function(complete){
                    if (complete){
                        loadScene(`Game`, { hierarchy: true, settings: true }, () => {
                            GameManager.instance.GameStart();
                        });
                    }
                });
            }
        });

    });
};

PlaceManager.prototype.newDefineScenePanel = function() {
    
    var levelIndex = 0;
    let allPlacesUnlocked = false;

    if (PlayerManager.instance.userData.newPlayer == false) {
        levelIndex = 0;
        customEventPlayStatus = true;
        
    }
    if ((PlayerManager.instance.userData.level == 1) || (PlayerManager.instance.userData.level == 2) || (PlayerManager.instance.userData.level == 3)) {

        if (PlayerManager.instance.levelData.levelName === "Hobby Room1") {
            loadLevelData = 1;
        }
        else if (PlayerManager.instance.levelData.levelName === "Hobby Room2") {
            loadLevelData = 2;
        }
        else {
            loadLevelData = 3;
        }
        levelIndex = 0;
    }
    else if ((PlayerManager.instance.userData.level == 4) || (PlayerManager.instance.userData.level == 5)) {
        if (PlayerManager.instance.levelData.levelName === "Kids Room1") {
            loadLevelData = 4;
        }
        else {
            loadLevelData = 5;
        }

        levelIndex = 1;
    }
    else if (PlayerManager.instance.userData.level == 6) {

        levelIndex = 2;
        loadLevelData = 6;
    }
    else if (PlayerManager.instance.userData.level == 7) {

        levelIndex = 3;
        loadLevelData = 7;
    }
    else if (PlayerManager.instance.userData.level == 8) {

        levelIndex = 4;
        loadLevelData = 8;
    }
    else if (PlayerManager.instance.userData.level == 9) {
 
        levelIndex = 5;
        loadLevelData = 9;
    }
    else if (PlayerManager.instance.userData.level == 10) {

        levelIndex = 6;
        loadLevelData = 10;
    }
    else if (PlayerManager.instance.userData.level == 11) {

        levelIndex = 7;
        loadLevelData = 11;
    }
    else if (PlayerManager.instance.userData.level == 12) {

        levelIndex = 8;
        loadLevelData = 12;
    }
    else if (PlayerManager.instance.userData.level == 13) {

        levelIndex = 9;
        loadLevelData = 13;
    }
    // else if (PlayerManager.instance.userData.level>13) {
    //     allPlacesUnlocked = true;
    // }
    allPlacesUnlocked = PlayerManager.instance.userData.unlockLevel;
        for (i = 0; i < 10; i++) {

            if (PlayerManager.instance.userData.newPlayer == true) {
                this.closePlaceItems[i].enabled = true;
                this.openPlaceItems[i].enabled = false;
            }
            else {
                if (allPlacesUnlocked == true) {
                    this.closePlaceItems[i].enabled = false;
                    this.openPlaceItems[i].enabled = true;
                    this.openPlaceItems[i].children[1].button.active = true;
                }
                else {
                    if (i <= levelIndex) {
                        this.closePlaceItems[i].enabled = false;
                        this.openPlaceItems[i].enabled = true;
                        this.openPlaceItems[i].children[1].button.active = true;

                    }
                    else {
                        this.closePlaceItems[i].enabled = true;
                        this.openPlaceItems[i].enabled = false;
                    }
                }
            }
        }
};


